/**
 * data-registry.ts — Singleton accessor for IDataService.
 *
 * main.ts calls setDataService() once after init(); everything else uses
 * getDataService(). Throws clearly if accessed before initialization to
 * make boot-order bugs loud.
 */

import type { IDataService } from './IDataService';

let instance: IDataService | null = null;

export function setDataService(service: IDataService): void {
  instance = service;
}

export function getDataService(): IDataService {
  if (!instance) {
    throw new Error('[data-registry] getDataService() called before setDataService()');
  }
  return instance;
}
